import { Injectable } from '@angular/core';

import { ApiService }                          from '../../api/api.service';
import { CodeTypeModel }                       from '../../core/models/code-type';
import { TableQueryParameters }                from '../../table/types/table-query-parameters';
import { TransactionCenterFiltersModel }       from '../typings/transaction-center.filters';
import { TransactionCenterVendorInvoiceModel } from './typings/transaction-center.vendor-invoice';

@Injectable({
  providedIn: 'root'
})
export class TransactionCenterVendorInvoicesService {
  public broadcastKey  = 'filterTransactionCenterVendorInvoices';
  public tableCacheKey = 'transactionCenterVendorInvoices';

  constructor (
    private apiService: ApiService
  ) {}

  get ( filters : TransactionCenterFiltersModel = {}, params : TableQueryParameters = {} ) : Promise<Array<TransactionCenterVendorInvoiceModel>> {
    return this.apiService.get('/transaction_center/supplier_invoices', [
        filters.startDate || '*',
        filters.endDate   || '*',
        filters.status    || 'I',
        filters.value     || '*',
        params.field      || 'post_date',
        params.direction  || 'desc',
        params.pageSize   || 10,
        params.offset     || 0
      ]);
  }

  getCount ( filters : TransactionCenterFiltersModel = {} ) : Promise<number> {
    return this.apiService.get('/transaction_center/supplier_invoices_count', [
        filters.startDate || '*',
        filters.endDate   || '*',
        filters.status    || 'I',
        filters.value     || '*'
      ])
      .then(( count : any ) => count.vendor_invoices_count);
  }

  getStatuses () : Promise<Array<CodeTypeModel>> {
    return this.apiService.get('/system/vendor_invoice_type_filters');
  }
}
